import React from 'react'
import PropTypes from 'prop-types'

export default class ErrorMessages extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { messages } = this.props

    if (messages === undefined || messages.length == 0) return null

    return (
      <div className="alert alert-warning">
        <ul className="list-unstyled">
          {
            messages.map((m, i) => <li key={i}><strong><i className="fas fa-exclamation-triangle"></i>{m}</strong></li>)
          }
        </ul>
      </div>
    )
  }
}

ErrorMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string.isRequired),
}

ErrorMessages.defaultProps = {
  messages: [],
}
